import { useEffect } from 'react';

const SITE = 'flory.sh';

/** Per-route <title> and meta description for the SPA (public SSR pages are rendered by the Worker). */
export function usePageMeta(title: string | null, description?: string) {
  useEffect(() => {
    document.title = title
      ? `${title} — ${SITE}`
      : `${SITE} — the open, agent-native professional network`;
    if (description) {
      let el = document.querySelector('meta[name="description"]');
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute('name', 'description');
        document.head.appendChild(el);
      }
      el.setAttribute('content', description);
    }
  }, [title, description]);
}
